export const Loading2Icon = ({
  width = 40,
  height = 40,
  title = "Loading",
  ...rest
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    {...rest}>
    <title>{title}</title>
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="m12.848 27.549 6.542 3.503a.829.829 0 0 0 .72.107l11.036-3.167a.838.838 0 0 0 .58-.8v-5.35a.38.38 0 0 0-.216-.343l-7.163-3.373-12.051 3.06.19 5.698c.01.267.143.514.362.665Z"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="m12.296 21.188-5.211-6.2a.673.673 0 0 1 .337-1.082l10.936-2.943c.26-.07.534.025.7.239l5.29 6.926"
    />
    <path
      fill="#00226A"
      stroke="#00226A"
      strokeMiterlimit={10}
      d="m19.201 24.923-6.527-3.62c-.075-.042-.06-.154.022-.175l11.653-3.001 7.02 3.305c.123.057.108.24-.023.276L19.74 24.985a.703.703 0 0 1-.536-.062H19.2Z"
    />
    <path
      fill="#5DCDFF"
      d="m33.178 17.274-.824.215a.446.446 0 0 0-.332.406l-.052.856c-.01.165-.224.22-.31.081l-.457-.723a.444.444 0 0 0-.486-.194l-.823.215c-.159.04-.277-.146-.173-.273l.54-.662a.455.455 0 0 0 .033-.527l-.456-.724c-.089-.139.052-.31.204-.25l.791.315c.18.07.383.018.507-.133l.54-.662c.104-.127.308-.046.299.12l-.052.855a.448.448 0 0 0 .28.445l.792.314c.152.06.139.282-.02.323l-.001.003ZM25.25 8.462l.21.83c.049.19.21.325.403.338l.849.055c.163.01.216.225.079.313l-.719.459a.452.452 0 0 0-.193.49l.21.831c.04.16-.145.278-.271.173l-.654-.548a.442.442 0 0 0-.522-.034l-.718.46c-.138.087-.308-.055-.247-.208l.314-.797a.451.451 0 0 0-.129-.511l-.653-.548c-.126-.105-.044-.312.118-.3l.848.055c.193.013.37-.101.442-.282l.315-.797a.168.168 0 0 1 .32.02h-.002ZM17.076 13.412l-.109.85a.448.448 0 0 1-.358.384l-.836.16c-.16.03-.188.25-.041.32l.768.367c.174.083.275.27.25.463l-.109.85c-.02.165.178.26.29.14l.583-.624a.44.44 0 0 1 .514-.097l.767.367c.148.07.3-.09.22-.236l-.408-.753a.453.453 0 0 1 .066-.523l.584-.624c.111-.119.006-.314-.154-.284l-.835.159a.444.444 0 0 1-.473-.226l-.408-.752c-.078-.145-.295-.104-.316.06l.005-.001Z"
    />
  </svg>
);
